import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import DropdownMenuElem from '../DropDownMenu/DropDownMenuElem/DropdownMenuElem';
import cn from 'classnames';
import styles from './LanguageMenu.module.scss';
import { firstLetterUpperCase } from '../../helpers';
import { setLanguage } from '../../store/reducers/Language/slice';
import { useDispatch, useSelector } from 'react-redux';
const LanguageMenu = ({ innerRef, closeModal }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const language = useSelector((state) => state.language.language);
    const languages = [
        {
            label: t('english'),
            value: 'en'
        }
    ];
    return (_jsx("div", Object.assign({ ref: innerRef, onClick: closeModal, className: cn(styles.element, 'd-flex flex-column') }, { children: _jsx("ul", { children: languages.map(({ label, value }) => (_jsx(DropdownMenuElem, Object.assign({ onClick: () => {
                    dispatch(setLanguage(value));
                    closeModal && closeModal();
                }, isActive: value === language }, { children: firstLetterUpperCase(label) }), label))) }) })));
};
export default LanguageMenu;
